import { NavLink } from 'react-router-dom';

import {
  IconUser,
  IconILAB,
  IconIBOSS,
  IconReports,
  IconBilling,
  IconCollaborators,
} from '~/assets/icons';
import { useAuth } from '~/hooks/auth.context';

import { Container } from './styles';

const MenuBottom = () => {
  const { user } = useAuth();

  return (
    <Container>
      {user?.role === 'admin' && (
        <>
          <NavLink to="/users">
            <section>
              <IconUser title="Usuários" />
            </section>
          </NavLink>

          <NavLink to="/ilab">
            <section>
              <IconILAB title="I.Lab" />
            </section>
          </NavLink>

          <NavLink to="/iboss">
            <section>
              <IconIBOSS title="I.Boss" />
            </section>
          </NavLink>

          <NavLink to="/collaborators">
            <section>
              <IconCollaborators title="Colaboradores" />
            </section>
          </NavLink>

          <NavLink to="/billing">
            <section>
              <IconBilling title="Faturamento" />
            </section>
          </NavLink>

          <NavLink to="/reports">
            <section>
              <IconReports title="Relatórios" />
            </section>
          </NavLink>
        </>
      )}

      {user?.role === 'collaborator' && (
        <>
          {user?.collaborator?.modules.includes('módulo 1') && (
            <NavLink to="/users">
              <section>
                <IconUser title="Usuários" />
              </section>
            </NavLink>
          )}

          {user?.collaborator?.modules.includes('módulo 2') && (
            <NavLink to="/ilab">
              <section>
                <IconILAB title="I.LAB" />
              </section>
            </NavLink>
          )}

          {user?.collaborator?.modules.includes('módulo 3') && (
            <NavLink to="/iboss">
              <section>
                <IconIBOSS title="I.BOSS" />
              </section>
            </NavLink>
          )}

          {user?.collaborator?.modules.includes('módulo 4') && (
            <NavLink to="/collaborators">
              <section>
                <IconCollaborators title="Colaboradores" />
              </section>
            </NavLink>
          )}

          {user?.collaborator?.modules.includes('módulo 5') && (
            <NavLink to="/reports">
              <section>
                <IconReports title="Relatórios" />
              </section>
            </NavLink>
          )}
        </>
      )}

      {/* <NavLink to="/coupons">
        <IconCoupons title="Cupons" />
      </NavLink> */}
    </Container>
  );
};

export default MenuBottom;
